import * as React from 'react';


export default class UploadPdf extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 62">
                <defs>
                    <path id="a" d="M48.941 11.596v45.816a2.824 2.824 0 0 1-2.823 2.823H2.824A2.824 2.824 0 0 1 0 57.412V2.824A2.824 2.824 0 0 1 2.824 0h34.522a3 3 0 0 1 2.12.879l8.596 8.595a3 3 0 0 1 .88 2.122z"/>
                </defs>
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(.53 .882)">
                        <use fill="#FFF" xlinkHref="#a"/>
                        <path stroke="#E4E4E4" strokeWidth="2" d="M47.941 11.596a2 2 0 0 0-.586-1.415L38.76 1.586A2 2 0 0 0 37.346 1H2.824A1.824 1.824 0 0 0 1 2.824v54.588c0 1.007.816 1.823 1.824 1.823h43.294a1.824 1.824 0 0 0 1.823-1.823V11.596z"/>
                    </g>
                    <path fill="#F15353" d="M6.176 17.823h37.647v4.706H6.176zM6.176 7.47H32.53v4.706H6.176zM6.176 28.176h37.647v4.706H6.176z" opacity=".1"/>
                    <path fill="#F15353" d="M36.884 5.728v6.89a.5.5 0 0 0 .5.5h6.889a.5.5 0 0 0 .354-.854l-6.89-6.89a.5.5 0 0 0-.853.354zM12.451 48.3v4.293h-2.51V40.412h4.752c.915 0 1.72.167 2.414.502.694.334 1.228.81 1.602 1.426.373.616.56 1.318.56 2.104 0 1.194-.408 2.135-1.225 2.824-.817.689-1.948 1.033-3.393 1.033h-2.2zm0-2.032h2.242c.664 0 1.17-.156 1.519-.469.348-.312.522-.758.522-1.338 0-.597-.175-1.08-.527-1.447-.351-.369-.836-.558-1.455-.57H12.45v3.824zm8.542 6.325V40.412h3.748c1.07 0 2.028.241 2.873.723a5.046 5.046 0 0 1 1.979 2.058c.474.89.711 1.9.711 3.033v.56c0 1.133-.233 2.14-.699 3.02a5.003 5.003 0 0 1-1.97 2.05c-.847.486-1.804.731-2.87.737h-3.772zm2.51-10.148v8.131h1.213c.981 0 1.731-.32 2.25-.962.519-.641.784-1.558.795-2.752v-.644c0-1.238-.257-2.177-.77-2.815-.513-.639-1.263-.958-2.25-.958h-1.239zm15.953 5.17h-4.818v4.978h-2.51V40.412h7.93v2.033h-5.42v3.145h4.818v2.025z"/>
                </g>
            </svg>
        )
    }
}
